import cn from 'classnames';
import React from 'react';
import Markdown from '../Markdown';
import styles from './QuestionDescription.module.css';

interface QuestionDescriptionProps {
  className?: string;
  alignment: 'left' | 'center';
  children?: string;
}

export const QuestionDescription = ({ className, alignment, children = '' }: QuestionDescriptionProps) => {
  const text = children.trim();

  if (!text) return null;

  return (
    <h2 className={cn(className, styles.description, { [c(styles.alignCenter)]: alignment === 'center' })}>
      <Markdown>{text}</Markdown>
    </h2>
  );
};
